export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center bg-background-950 overflow-hidden pt-[72px]">
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-950"></div>
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20dark%20futuristic%20network%20visualization%20with%20glowing%20coral%20orange%20nodes%20and%20connecting%20lines%20on%20near%20black%20background%2C%20digital%20data%20flow%2C%20cyber%20aesthetic%2C%20minimal%20geometric%20patterns%2C%20cinematic%20lighting%2C%20editorial%20design%2C%20high%20contrast%2C%20sophisticated%20and%20mysterious%20atmosphere&width=1800&height=1200&seq=hero-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-40"
      />

      <div className="relative z-10 w-full px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 flex flex-col items-start pt-6 md:pt-12 w-full">
            <span className="inline-block px-3 py-1.5 bg-accent-500/15 text-accent-400 text-xs md:text-sm font-semibold rounded-full mb-4 md:mb-6 tracking-wide">
              全网独家 · 实时更新
            </span>

            <h1 className="text-white font-heading font-black leading-[1.08] mb-3 md:mb-4">
              <span className="block text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tight">爆料网</span>
              <span className="block text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-accent-400 mt-1">一手猛料不打烊</span>
            </h1>

            <p className="text-secondary-300 text-base md:text-lg font-medium mb-5 md:mb-6 leading-relaxed">
              911爆料网与51爆料网每日黑料爆料 | 网红吃瓜大瓜实时追踪
            </p>

            <div className="text-foreground-200/80 text-sm md:text-base leading-relaxed mb-5 md:mb-7 max-w-xl space-y-3">
              <p>
                爆料网汇聚全网最具热度的网红黑料、明星八卦与社会热点猛料。我们每日实时追踪911爆料网、51爆料网、91爆料网等平台的一手信息，
                为吃瓜群众提供最及时、最全面的独家爆料内容聚合。从反差人设崩塌到行业黑幕曝光，从饭圈塌房实录到社会事件真相追踪，
                每一则爆料都经过多源交叉验证，确保信息新鲜度与可信度。
              </p>
              <p>
                覆盖热门吃瓜网站全生态，实时同步今日最新事件爆料网址更新。无论你是偶尔围观的路人，还是深度追踪的吃瓜老饕，
                这里都能找到你想要的猛料内容。全网吃瓜群众的选择，掌握今日大瓜不迷路。
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-4 md:gap-8 mb-6 md:mb-8">
              <div className="flex flex-col">
                <span className="text-accent-400 text-xl md:text-2xl font-bold font-label">实时追踪</span>
                <span className="text-secondary-400 text-xs mt-0.5">每日更新不停更</span>
              </div>
              <div className="w-px h-8 bg-white/10 hidden sm:block"></div>
              <div className="flex flex-col">
                <span className="text-white/80 text-xl md:text-2xl font-bold font-label">全网覆盖</span>
                <span className="text-secondary-400 text-xs mt-0.5">多平台同步聚合</span>
              </div>
              <div className="w-px h-8 bg-white/10 hidden sm:block"></div>
              <div className="flex flex-col">
                <span className="text-white/80 text-xl md:text-2xl font-bold font-label">安全匿名</span>
                <span className="text-secondary-400 text-xs mt-0.5">保护投稿者隐私</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
              <a
                href="#carousel"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-accent-500 hover:bg-accent-600 text-white font-semibold text-sm rounded-full transition-colors whitespace-nowrap"
              >
                <i className="ri-flashlight-line"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-white/25 hover:border-white/50 text-white/80 hover:text-white font-medium text-sm rounded-full transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-send-line"></i>
                联系投稿
              </a>
            </div>
          </div>

          <div className="flex-1 w-full lg:max-w-[480px] xl:max-w-[540px] flex items-center justify-center">
            <div className="relative w-full aspect-[4/5] max-w-sm md:max-w-md lg:max-w-none">
              <div className="absolute -inset-2 bg-accent-500/10 rounded-3xl blur-2xl"></div>
              <div className="relative grid grid-cols-2 grid-rows-2 gap-2.5 md:gap-3 h-full">
                <div className="rounded-2xl md:rounded-3xl overflow-hidden bg-background-800 row-span-2">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dramatic%20moody%20portrait%20silhouette%20of%20person%20against%20dark%20backdrop%20with%20coral%20orange%20accent%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20fashion%20photography%2C%20high%20contrast%20chiaroscuro%2C%20cinematic%20noir%20style%2C%20abstract%20emotional%20expression&width=600&height=900&seq=hero-visual-1&orientation=portrait"
                    alt="独家爆料追踪"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="rounded-2xl md:rounded-3xl overflow-hidden bg-background-800">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20social%20media%20and%20news%20headlines%20collage%2C%20abstract%20digital%20chaos%2C%20glowing%20coral%20orange%20accents%20on%20dark%20background%2C%20fragmented%20text%20overlay%2C%20editorial%20design%2C%20high%20contrast%20cinematic%20lighting%2C%20modern%20media%20aesthetic&width=600&height=400&seq=hero-visual-2&orientation=landscape"
                    alt="热点新闻聚合"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="rounded-2xl md:rounded-3xl overflow-hidden bg-background-800">
                  <img
                    src="https://readdy.ai/api/search-image?query=Mysterious%20anonymous%20figure%20typing%20on%20laptop%20in%20dark%20room%2C%20coral%20orange%20screen%20glow%20illuminating%20face%2C%20whistleblower%20aesthetic%2C%20investigative%20journalism%2C%20noir%20cinematography%2C%20high%20contrast%2C%20suspenseful%20mood%2C%20abstract%20digital%20leaks%20theme&width=600&height=400&seq=hero-visual-3&orientation=landscape"
                    alt="匿名投稿"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a href="#carousel" className="flex flex-col items-center gap-2 text-white/40 hover:text-white/70 transition-colors">
          <span className="text-xs tracking-widest uppercase">向下滚动</span>
          <i className="ri-arrow-down-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}